import formatBytes from './filters/formatBytes.js';
import formatDate from './filters/formatDate.js';
//import addLeadingZero from './filters/addLeadingZero';
var  customFilters = {
  formatBytes: formatBytes,
  formatDate: formatDate
}
export default customFilters;